import { Form, Checkbox, Select } from "antd";

const Map = ({ selectedAgents, setSelectedAgents }) => {
  // const style = {
  //   display: "flex",
  //   flexDirection: "column",
  //   gap: 8,
  // };

  // const onChange = (e) => {
  //   setSelectedAgents(e.target.value);
  // };
  return (
    <div className="video-url-container">
      <h4 style={{ margin: "10px 0px 20px 0px" }}>
        Please select both the Listing Owner and Listing Agent for this
        property.
      </h4>
      {/* Listing Agent */}
      <Form.Item
        name="listing_agent"
        label="Listing Agent"
        rules={[{ required: false, message: "This field is required" }]}
      >
        <Select
          options={[
            {
              value: "",
              label: "Please select",
            },
            {
              value:
                "290383-Madhav Grover-madhav.g@empireinfratech.ae-971542119563",
              label: "Madhav Grover",
            },
            {
              value:
                "322838-Yasemin Goekce Doelek-yasemin.dolek@empireinfratech.ae-971503656069",
              label: "Yasemin Goekce Doelek",
            },
          ]}
        />
      </Form.Item>
      {/* listing_owner */}
      <Form.Item
        name="listing_owner"
        label="Listing Owner"
        rules={[{ required: false, message: "This field is required" }]}
      >
        <Select
          options={[
            { value: "", label: "Please select" },
            { value: "Mohammad Shoaib", label: "Mohammad Shoaib" },
            { value: "Aaryan Daboria", label: "Aaryan Daboria" },
            { value: "Abdul Razak Bello", label: "Abdul Razak Bello" },
            { value: "admin undefined", label: "admin undefined" },
            { value: "Ahmed Sayed", label: "Ahmed Sayed" },
            { value: "Almigdad Mohamed", label: "Almigdad Mohamed" },
            { value: "Alodia Sophia", label: "Alodia Sophia" },
            { value: "aly Mohammed", label: "aly Mohammed" },
            { value: "arian nikbin", label: "arian nikbin" },
            { value: "Ashraf Arab", label: "Ashraf Arab" },
            { value: "aya haidar", label: "aya haidar" },
            { value: "Baninla Larissa", label: "Baninla Larissa" },
            { value: "Benzy Aman", label: "Benzy Aman" },
            { value: "Betty A", label: "Betty A" },
            { value: "Danna Buskunova", label: "Danna Buskunova" },
            { value: "Devina Lathakumari", label: "Devina Lathakumari" },
            { value: "elsayed Mohamed", label: "elsayed Mohamed" },
            { value: "Faisal Qureshi", label: "Faisal Qureshi" },
            { value: "Gift Nwaobia", label: "Gift Nwaobia" },
            { value: "Gloria  Naomi", label: "Gloria  Naomi" },
            { value: "Guharsha  R", label: "Guharsha  R" },
            { value: "Hawanette Lebbie", label: "Hawanette Lebbie" },
            { value: "James G.", label: "James G." },
            { value: "Kavmadee Fernando", label: "Kavmadee Fernando" },
            { value: "Kunwar Deep", label: "Kunwar Deep" },
            { value: "leaticia bih", label: "leaticia bih" },
            { value: "Linda undefined", label: "Linda undefined" },
            { value: "Madhav Grover", label: "Madhav Grover" },
            { value: "madhav undefined", label: "madhav undefined" },
            { value: "Maita  Rose", label: "Maita  Rose" },
            { value: "Maroof Haider", label: "Maroof Haider" },
            { value: "michael undefined", label: "michael undefined" },
            { value: "Mohamed Basith", label: "Mohamed Basith" },
            { value: "Ms Jai Morarji", label: "Ms Jai Morarji" },
            { value: "Payal Chopra", label: "Payal Chopra" },
            { value: "Robin Chaturvedi", label: "Robin Chaturvedi" },
            { value: "Saman Mehraban", label: "Saman Mehraban" },
            { value: "sara undefined", label: "sara undefined" },
            { value: "Shilpa", label: "Shilpa" },
            { value: "tareq alsheikh", label: "tareq alsheikh" },
            { value: "Touran Poursharaf", label: "Touran Poursharaf" },
            { value: "Vortexweb Web", label: "Vortexweb Web" },
            { value: "Yasemin Dölek", label: "Yasemin Dölek" },
          ]}
        />
      </Form.Item>
      {selectedAgents === "Display Agent(s) Information" && (
        <div>
          <Form.Item
            name="selectedAgents"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              mode="multiple"
              placeholder="Select Agent"
              options={[
                {
                  label: "Empire Infratech",
                  value: "Empire Infratech",
                },
              ]}
            />
          </Form.Item>
        </div>
      )}
      {/* acceptTermsAndConditions */}
      <Form.Item
        name="acceptTermsAndConditions"
        valuePropName="checked" // This binds the checkbox value to the form data
        rules={[{ required: true, message: "Accept Terms & Conditions" }]}
      >
        <Checkbox>
          Accept Terms & Conditions before property submission.
        </Checkbox>
      </Form.Item>
    </div>
  );
};

export default Map;
